import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LayoutTable from "./layout/Table";
import { useGlobalContext } from "../../../App";
import AddCategoryPopup from "./component/AddCategoryPopup";
import { getAllCategories } from "../../../services/category";
import Search from "../../../shared/components/Search";

type Props = {};

export interface ActionMenuProps {
  title: string;
  action: () => void;
  actionTitle: string;
}

const tableRef = React.createRef<any>();

const CategoryList = (props: Props) => {
  const { addCollectionUI, setAddCategoryPopup, addCategoryPopup } =
    useGlobalContext();
  const columnItems = [{ id: "Name", label: "Name" }];

  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [componentCategoriesList, setComponentCategoriesList] = useState<any>(
    []
  );

  const handleCloseAddCategoryPopup = () => {
    setAddCategoryPopup(!addCategoryPopup);
  };
  const fetchComponentCategories = async (filters?: any) => {
    setLoading(true);
    await getAllCategories(filters)
      .then((res: any) => {
        setLoading(false);
        setComponentCategoriesList(res);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const filteredCategories = search
    ? componentCategoriesList?.paginatedConstantValues?.filter(
        (category: any) =>
          category.value.toLowerCase().includes(search.toLowerCase())
      ) || []
    : componentCategoriesList?.paginatedConstantValues || [];

  useEffect(() => {
    fetchComponentCategories({ type: "COMPONENT_CATEGORY" });
  }, []);

  useEffect(() => {}, [componentCategoriesList]);

  const handleRefreshData = () => {
    fetchComponentCategories({ type: "COMPONENT_CATEGORY" });
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          paddingY: "24px",
        }}
      >
        {/* Seach input  */}
        <Box sx={{ width: "85%", mb: "16px" }}>
          <Box sx={{ width: "100%", height: "76px" }}>
            <Search
              style={{
                height: "76px",
                color: "white",
                backgroundColor: "#1A1A1A",
                paddingLeft: "40px",
                boxShadow: "none",
                borderRadius: "14px",
                fontSize: "18px",
                fontWeight: "500",
              }}
              placeholder="Search categories"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
        </Box>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              right: 0,
              left: 0,
              bottom: 0,
              top: 120,
              height: "100%",
            }}
          >
            <CircularProgress
              size={24}
              sx={{
                color: "white",
                marginRight: "12px",
              }}
            />
          </Box>
        ) : componentCategoriesList?.paginatedConstantValues?.length > 0 ? (
          <>
            <Box
              sx={{
                width: "100%",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <Box
                  sx={{
                    width: "85%",
                  }}
                >
                  <LayoutTable
                    loading={loading}
                    // rows={componentCategoriesList?.paginatedConstantValues}
                    rows={filteredCategories || []}
                    columns={columnItems}
                    handleRefreshData={handleRefreshData}
                  />
                </Box>
              </Box>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "60vh",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white" }} variant="h5">
              No Categories to display
            </Typography>
          </Box>
        )}
      </Box>
      {/* ------------Add collections Form----------- */}
      {addCategoryPopup && (
        <AddCategoryPopup
          activeDialog={addCategoryPopup}
          handleDialog={handleCloseAddCategoryPopup}
          handleRefreshData={handleRefreshData}
        />
      )}
    </>
  );
};

export default CategoryList;
